<template>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <button
        class="btn-close p-0"
        type="button"
        data-bs-dismiss="modal"
        aria-label="Close"
        style="background: transparent"
        @click="closeModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 35 35"
          fill="none"
        >
          <circle cx="17.5" cy="17.5" r="17.5" fill="#A3A3A3" />
          <path
            d="M17.5 0C7.84972 0 0 7.85167 0 17.5C0 27.1483 7.84972 35 17.5 35C27.1503 35 35 27.1483 35 17.5C35 7.85167 27.1503 0 17.5 0ZM17.5 32.5C9.99639 32.5 2.5 25.0056 2.5 17.5C2.5 9.99444 9.99639 2.5 17.5 2.5C25.0036 2.5 32.5 9.99444 32.5 17.5C32.5 25.0056 25.0036 32.5 17.5 32.5ZM18.8747 17.5L24.0197 12.355C24.202 12.1727 24.3044 11.9254 24.3044 11.6676C24.3044 11.4098 24.202 11.1626 24.0197 10.9803C23.8374 10.798 23.5902 10.6956 23.3324 10.6956C23.0746 10.6956 22.8273 10.798 22.645 10.9803L17.5 16.1253L12.355 10.9783C12.1716 10.8012 11.9261 10.7032 11.6711 10.7055C11.4162 10.7077 11.1724 10.8099 10.9921 10.9902C10.8119 11.1704 10.7096 11.4143 10.7074 11.6692C10.7052 11.9241 10.8032 12.1697 10.9803 12.3531L16.1253 17.5L10.9803 22.645C10.7977 22.8273 10.6951 23.0747 10.6949 23.3326C10.6947 23.5906 10.797 23.8381 10.9793 24.0207C11.1616 24.2033 11.409 24.3059 11.667 24.3061C11.9249 24.3063 12.1724 24.204 12.355 24.0217L17.5 18.8747L22.645 24.0197C22.7346 24.1127 22.8417 24.1869 22.9603 24.238C23.0788 24.2891 23.2063 24.3161 23.3354 24.3174C23.4645 24.3187 23.5926 24.2943 23.7121 24.2456C23.8317 24.1969 23.9403 24.1248 24.0317 24.0337C24.1231 23.9425 24.1955 23.8341 24.2445 23.7147C24.2936 23.5953 24.3184 23.4673 24.3174 23.3382C24.3165 23.2091 24.2899 23.0815 24.2391 22.9628C24.1883 22.8441 24.1144 22.7368 24.0217 22.6469L18.8747 17.5Z"
            fill="white"
          />
        </svg>
      </button>
      <div class="modal-header">
        <h5 class="modal-title title-header">List of Light(s)</h5>
      </div>
      <div class="modal-body custom-scrollbar">
        <div class="row mb-3">
          <div class="form-group w-auto position-relative">
            <input
              class="form-control btn-search"
              type="text"
              required=""
              placeholder="Search records"
              v-model="search"
            />
            <i class="icofont icofont-search-alt-2"></i>
          </div>
        </div>
        <div class="row">
          <div class="col-12 p-0">
            <div class="row g-4 position-relative custom-scrollbar">
              <div class="col-12">
                <!-- :items="items" -->
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :items="filteredItems"
                  :server-items-length="serverItemsLength"
                  :loading="loading"
                  :headers="Headers"
                  :rows-items="rowItems"
                  buttons-pagination
                  table-class-name="customize-table"
                  rows-per-page-message=""
                  theme-color="#0492FF"
                  show-index-symbol="No."
                  show-index
                >
                  <template #item-index="{ index }">
                    <div class="number">
                      {{ index }}
                    </div>
                  </template>
                  <template #item-view="data">
                    <div class="view-light" @click="() => viewLight(data)">
                      View >>
                    </div>
                  </template>
                  <template #header-Status="header">
                    <div class="w-100 d-flex justify-content-center">
                      {{ header.text }}
                    </div>
                  </template>
                  <template #item-Status="{ Status }">
                    <div class="w-100 d-flex justify-content-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <circle
                          cx="7.5"
                          cy="7.5"
                          r="7.5"
                          :fill="Status === 'Green' ? '#218863' : '#FA0000'"
                        />
                      </svg>
                    </div>
                  </template>
                </EasyDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mockServerItems } from "@/data/api/listLight";

export default {
  props: ["list"],
  data() {
    return {
      search: "",
      filteredItems: [],
      Headers: [
        {
          text: "Device Name",
          value: "DeviceName",
          sortable: false,
        },
        {
          text: "Status",
          value: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "View Light",
          value: "view",
          sortable: false,
        },
      ],
      isEdit: false,
      rowItems: [5, 10, 50, 100],
      // rowItems: [1, 2, 3],
      // items: [],
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 5,
        // optionally: sortBy, sortType
      },
      // serverOptions: {
      //   page: 1,
      //   rowsPerPage: 5,
      // },
      loading: false,
      formEdit: {},
    };
  },
  computed: {
    // restApiUrl() {
    //   const { page, rowsPerPage, sortBy, sortType } = this.items;
    //   if (sortBy && sortType) {
    //     return `http://localhost:8080/api?page=${page}&limit=${rowsPerPage}&sortBy=${sortBy}&sortType=${sortType}`;
    //   } else {
    //     return `http://localhost:8080/api?page=${page}&limit=${rowsPerPage}`;
    //   }
    // },
  },
  watch: {
    serverOptions() {
      this.loadFromServer();
    },
    list: {
      immediate: true,
      handler(newItems) {
        console.log("list masuk");
        this.loadFromServer();
        this.serverItemsLength = this.filteredItems.length;
      },
    },
    search: {
      handler() {
        this.applyFilter(this.list);
      },
      immediate: false,
    },
  },
  methods: {
    applyFilter(sourceItems) {
      const keyword = this.search.trim().toLowerCase();
      if (!keyword) {
        this.filteredItems = sourceItems;
      } else {
        this.filteredItems = sourceItems.filter((item) =>
          item.DeviceName.toLowerCase().includes(keyword)
        );
      }
    },

    closeModal() {
      this.$emit("close-modal");
    },
    initializeModal() {
      this.loadFromServer();
    },
    viewLight(data) {
      console.log(data);
      this.closeModal();

      window.location.href =
        "/light?id=" + data.DeviceID + "&clusterId=" + data.clusterID;
      // this.$router.push("/light?id=" + data.DeviceID + "&clusterId=" + data.clusterID);
    },
    async loadFromServer() {
      console.log("masuk load from server");
      this.hidePaginationIndex();
      this.loading = true;

      const { serverCurrentPageItems, serverTotalItemsLength } =
        await mockServerItems(this.serverOptions, this.list);

      this.filteredItems = serverCurrentPageItems;
      // this.list = serverCurrentPageItems;
      this.serverItemsLength = serverTotalItemsLength;

      this.hidePaginationIndex();
      this.loading = false;
    },
    hidePaginationIndex() {
      const paginationIndex = document.querySelector(
        ".pagination__items-index"
      );
      const paginationRowInput = document.querySelector(".rows-input");
      if (!paginationIndex || !paginationRowInput) return;
      setTimeout(() => {
        paginationIndex.innerHTML = "";
        paginationRowInput.innerHTML = "View";
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.view-light {
  color: #218863;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.modal-dialog {
  max-width: 764px;
  max-height: calc(100vh - 120px);
}

.modal-content {
  max-height: calc(100vh - 120px);
  border: none;
}

.modal-body {
  padding: 30px;
  height: 100%;
  overflow-y: scroll;
}

.modal-header {
  border-radius: 8px 8px 0px 0px;
  background: linear-gradient(90deg, #bcefdc 0%, #a1cde7 100%);
  height: 63px;
  color: #218863;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.btn-close {
  width: 35px;
  height: 35px;
  position: absolute;
  top: -2px;
  right: -44px;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
}

.form-group i {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 22px;
  width: 24px;
  height: 24px;
  font-size: 24px;
  font-weight: bold;
  color: #a3a3a3;
}

.btn-search {
  display: flex;
  width: 215px;
  height: 44px;
  padding: 8px 13px 8px 45px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;
  color: #a3a3a3;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;

  &::placeholder {
    color: #d8d8d8;
    font-style: italic;
  }

  &:focus {
    outline: none;
  }
}

:deep(.customize-table) {
  --easy-table-tbody-row: #f6f6f6;
}
</style>
